module.exports = __webpack_public_path__ + "static/img/video2.1035efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPhonePage/video2.png
// module id = 7NGl
// module chunks = 0